(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(v, dec) {
    return dec ? v.toFixed(dec) : Math.round(v).toLocaleString('en-US');
  }

  function runCount(el) {
    var target = parseFloat(el.dataset.count);
    var dec = parseInt(el.dataset.decimals || '0', 10);
    var suf = el.dataset.suffix || '';
    if (reduce) {
      el.textContent = fmt(target, dec) + suf;
      return;
    }
    var dur = 1600;
    var start = null;
    function tick(now) {
      if (start === null) start = now;
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased, dec) + suf;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var revealIO = null;
  var statsIO = null;
  var karaokeIO = null;

  function observeReveal(root) {
    var els = (root || document).querySelectorAll('.koala-reveal:not([data-koala-observed]), .koala-stagger:not([data-koala-observed])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            revealIO.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });
    }
    els.forEach(function (el) { el.dataset.koalaObserved = '1'; revealIO.observe(el); });
  }

  function observeStats(root) {
    var stats = (root || document).querySelectorAll('[data-koala-stats]:not([data-koala-observed])');
    if (!stats.length) return;
    if (!('IntersectionObserver' in window)) {
      stats.forEach(function (el) { el.querySelectorAll('[data-count]').forEach(runCount); });
      return;
    }
    if (!statsIO) {
      statsIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('[data-count]').forEach(runCount);
            statsIO.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -10% 0px' });
    }
    stats.forEach(function (el) { el.dataset.koalaObserved = '1'; statsIO.observe(el); });
  }

  function observeKaraoke(root) {
    var els = (root || document).querySelectorAll('[data-koala-karaoke]:not([data-koala-observed])');
    if (!els.length) return;
    els.forEach(function (el) {
      el.dataset.koalaObserved = '1';
      if (reduce) {
        el.classList.add('koala-kw-wrap', 'in');
        return;
      }
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words
        .map(function (w, i) { return '<span class="koala-kw" style="transition-delay:' + i * 65 + 'ms">' + w + '</span>'; })
        .join(' ');
      el.classList.add('koala-kw-wrap');
    });
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!karaokeIO) {
      karaokeIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            karaokeIO.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
    }
    els.forEach(function (el) { karaokeIO.observe(el); });
  }

  function initAll(root) {
    /* Each feature is isolated: a bug/exception in one (e.g. reveal) must
       never prevent the others (e.g. the stats counter) from initializing. */
    try { observeReveal(root); } catch (err) { /* no-op */ }
    try { observeStats(root); } catch (err) { /* no-op */ }
    try { observeKaraoke(root); } catch (err) { /* no-op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-scan a section after it's reloaded/reordered so new or
     edited content still gets the reveal/karaoke/counter treatment. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* Safety net: if a section's markup is inserted into the page after our
     initial scan (theme editor re-renders, app embeds, delayed hydration),
     pick it up automatically instead of it silently never animating. */
  if ('MutationObserver' in window) {
    var rescanTimer = null;
    var domObserver = new MutationObserver(function () {
      clearTimeout(rescanTimer);
      rescanTimer = setTimeout(function () { initAll(document); }, 150);
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
